module.exports = __webpack_public_path__ + "static/media/Medicine Drug Facts.9dd4ed9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/cont/Medicine Drug Facts.png
// module id = 1187
// module chunks = 0